<template>
  <div>
    <div class="row" v-if="lokasyon.Data.Hata !== ''">
      <div class="col-md-12">
        <b-alert show variant="danger">{{ lokasyon.Data.Hata }}</b-alert>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-md-12">
        <div id="map" :data-lat="lokasyon.Data.lat" :data-lon="lokasyon.Data.lon"
          :data-title="mutationTransfer.Detay.Sofor.Plaka"
          :data-desc="lokasyon.Data.address + ' / Son Lokasyon Tarihi : ' + lokasyon.Data.time"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    transfer: null
  },
  data() {
    return {
      mutationTransfer: this.transfer,
      lokasyon: null
    };
  },
  components: {
  },
  mounted() {
    this.onLokasyon();
  },
  methods: {
    onLokasyon() {
      let vm = this;

      this.$connection.get(
        "/laalTransferler/lokasyon/" + this.mutationTransfer.Id,
        function (response) {
          console.log(response);
          if (response.Success) {
            vm.lokasyon = response;
          }
        },
        function (error) {
          vm.$alert.messageWithTitle("Araç Nerede", error.Message, "error");
          vm.$emit("onClose");
        }
      );
    },
  },
};
</script>